import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const CustomerLayoutWithoutHeaderFooter = loadable(
  () => import('./customerlayoutWithoutHeaderFooter.layout'),
  {
    fallback: <FullPageLoader />,
  }
);
